module.exports = __webpack_public_path__ + "img/potrait-user-omni.eeba1b8d.png";